/**
 * UstAciOzmo - Ozmo üst açı kontrol sınıfı
 * Ported from old system - B Açısı (Üst)
 */

import * as THREE from 'three';
import { MathUtils } from 'three';
const { degToRad } = MathUtils;
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FikoYTKokBilesenComponent } from "@/src/service/kok-bilesen/kok-bilesen.component";
import { FikoGrupCizim } from '../../IFikoThreeJS/FikoGrupCizim';
import { FikoCizimYalin } from '../../IFikoThreeJS/FikoCizimYalin';
import { FikoImporterWRL } from '../../IFikoThreeJS/FikoImporter.WRL';
import { FikoSahne } from '../../IFikoThreeJS/FikoSahne';
import { FikoVektor3D } from '../../IFikoThreeJS/FikoVektor3d';

/**
 * Ozmo Üst Açı Ek Panel Component - Hızlı 3D Menü için
 */
@Component({
  selector: 'fikoyt-ozmo-ust-aci-3d-ek-bilesen',
  standalone: true,
  template: `
    <div style="background-color: transparent; text-shadow: 0 0 10px rgb(0 255 255 / 95%);color: white;max-width:100%;">
      <div style="display: flex;align-items: center;justify-content: center;">
        <div style="display: flex;flex-direction: column;max-width: 500px;">
          <div>
            <div style="color:yellow;">
              Açıklama :
            </div>
            <div> Eğer Üst Açı Ve Alt Açı Sıfırda İken 3D Görüntüdeki Gibi Gözükmüyorsa Alttaki Kutucuktan Gerekli Ayarlamaları Yapabilirsiniz. </div>
          </div>

          <span style="flex:0;">
            <div style="display: flex;align-items:center;">
              <span style="color:yellow;">
                Kalibre Açısı :
              </span>
              <input [(ngModel)]="element.kalibrasyon" (ngModelChange)="aciDegisti();" class="fikoinput" type="number" placeholder="Seç" size="1" style="flex:1;">
            </div>
          </span>

          <div style="color:yellow;">
            Açı Artım Yönü :
          </div>
          <div> Üst Açıyı Çevirdiğinizde Saat Yönündemi Yoksa Tersi Yöndemi Artıyor.Bunu Aşağıdaki Kutucuktan Belirleyebilirsiniz </div>
          <select [(ngModel)]="element.yon" (ngModelChange)="aciDegisti();" style="margin-bottom:0.5em;">
            <option value="1">Saat Yönünün Tersi</option>
            <option value="2">Saat Yönünde</option>
          </select>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host{
        color:black;
        font-size:0.75rem;
        background-color: rgba(0, 127, 127, 0.7);
        border-radius: 0.5em;
        border-bottom-right-radius: 0.5em;
        border-bottom-left-radius: 0.5em;
        border: 1px solid rgba(127, 255, 255, 0.25);
        padding: 1px 5px;
        box-shadow: 0px 0px 12px rgb(0 255 255 / 50%);
        pointer-events:all;
    }

    .fikoinput {
        background-color: rgba(0, 127, 127, 0.7);
        box-shadow: 0px 0px 12px rgb(0 255 255 / 50%);
        border: 1px solid rgba(127, 255, 255, 0.5);
        color: white;

        outline: none;
        width: 100%;
    }

    select{
        color:black;
        outline:none;
    }
  `],
  imports: [CommonModule, FormsModule]
})
export class FikoOzmoUstAciEkBilesen extends FikoYTKokBilesenComponent {
  @Input() element: any;

  constructor() {
    super();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnInit(): void {}

  aciDegisti() {
    this.element.userData['FikoParametreler'][0].degisti(this.element.userData['FikoParametreler'][0].degeri);
    this.element?.sahne?.anaGosterim?.ciz();
  }
}

export class UstAciOzmo extends FikoGrupCizim {
  override type: any = "UstAciOzmo";

  /** Açı değerleri */
  aci: number = 0;
  aciMesh: any = null;
  kalibrasyon: number = 0;
  yon: "1" | "2" = "1";

  /** FikoParametreler için degeri ve degisti property'leri */
  degeri: number = 0;

  /** Hızlı 3D menü */
  hizli3DMenu = [
    {
      simgeYazi: "👁‍🗨",
      baslik: "Gizle / Göster",
      renkSinif: "yellow",
      tiklandi: () => {
        this.visible = !this.visible;
        this.sahne?.anaGosterim?.FikoYT?.degisti?.emit();
      }
    },
  ];

  /** Hızlı menü ek bileşen - Ozmo için özel panel */
  hizliMenu3DEk = FikoOzmoUstAciEkBilesen;
  hizliMenu3DEkParametreler: { element: any } = { element: this };

  constructor(public override sahne?: FikoSahne, name?: string) {
    super(sahne);

    this.name = name || "Üst Açı.1";

    // 3D modeli yükle
    const importer = new FikoImporterWRL(this.sahne);
    importer.alUrlden("./assets/3D/Tav-20-Kafa/UST.FikoCizim").then((
      _rslt: { yuzeyler: THREE.BufferGeometry<THREE.NormalBufferAttributes>, cizgiler: any, vertex: any }[]
    ) => {
      for (let i = 0; i < _rslt.length; i++) {
        const e = _rslt[i];
        this.aciMesh = new FikoCizimYalin(this.sahne, name ?? "Üst Açısı", e.yuzeyler, e.cizgiler, e.vertex);
        this.aciMesh.name += "." + (i + 1);
        this.aciMesh.userData['FikoArayuz'].agactaGorunur = false;
        this.aciMesh.userData['FikoArayuz'].listeGoster = false;
        this.ekle(this.aciMesh);
      }
      this.sahne?.anaGosterim?.ciz();
    }).catch(error => {
      // Basit placeholder geometry oluştur
      const geometry = new THREE.BoxGeometry(10, 10, 10);
      const material = new THREE.MeshPhongMaterial({ color: 0xFF6600 });
      this.aciMesh = new THREE.Mesh(geometry, material);
      this.aciMesh.name = name ?? "Üst Açısı (Placeholder)";
      this.ekle(this.aciMesh);
      this.sahne?.anaGosterim?.ciz();
    });

    this.userData['FikoArayuz'].agactaGorunur = true;
    this.userData['FikoArayuz'].listeGoster = true;
    this.userData['FikoArayuz'].simge = "./assets/simgeler/kurdela.webp";

    // FikoParametreler yapılandırması
    this.userData['FikoParametreler'] = [
      {
        turu: "Çubuk",
        ayar: {
          min: 0,
          maks: 360,
          adim: 0.1
        },
        degeri: this.aci,
        degisti: (dgr?: number) => {
          if (dgr !== undefined) {
            this.aci = dgr;
            this.degeri = dgr;
          }

          // Rotasyonu ayarla
          if (this.yon == "2") {
            this.setRotationFromAxisAngle(
              new FikoVektor3D(0, 0, 1),
              degToRad(180 - (this.kalibrasyon + this.aci))
            );
          } else if (this.yon == "1") {
            this.setRotationFromAxisAngle(
              new FikoVektor3D(0, 0, 1),
              degToRad(180 - (this.kalibrasyon + (360 - this.aci)))
            );
          }

          this.sahne?.anaGosterim?.ciz();
        }
      }
    ];
  }

  /**
   * Açı değiştir - dialog'dan çağrılacak
   */
  degisti(deger: number): void {
    if (this.userData['FikoParametreler']?.[0]) {
      this.userData['FikoParametreler'][0].degisti(deger);
    }
  }

  /**
   * PERFORMANS: Raycast override - hızlı 3D menü için
   * Sadece kendi aciMesh'ini yakala, alt açı mesh'lerini değil
   */
  override raycast(raycaster: THREE.Raycaster, intersects: THREE.Intersection[]): void {
    if (!this.visible) return;
    if (this.children.length < 1) return;
    if (!this.aciMesh) return;

    // Sadece kendi mesh'ini yakala - diğer açıların mesh'lerini yakalama
    let kesisenler = raycaster.intersectObject(this.aciMesh, true);

    if (kesisenler.length > 0) {
      const firstHit = kesisenler[0];
      intersects.push({
        object: this,
        distance: firstHit.distance,
        point: firstHit.point,
        face: firstHit.face,
        faceIndex: firstHit.faceIndex,
        index: firstHit.index,
        //@ts-ignore
        instanceId: this.id,
        //@ts-ignore
        altObje: firstHit.object,
        //@ts-ignore
        grup: this,
        //@ts-ignore
        enUstte: false,
        //@ts-ignore
        secilebilir: true,
        //@ts-ignore
        hizli3DMenu: this.hizli3DMenu,
        //@ts-ignore
        hizliMenu3DEk: this.hizliMenu3DEk,
        //@ts-ignore
        hizliMenu3DEkParametreler: this.hizliMenu3DEkParametreler
      } as any);
    }
  }
}
